import { FinancialConnection } from "./financialConnection";

export enum StripeConnectionErrorType {
    DISCONNECTED = "disconnected",
}

// Reflects the OAuth grant Stripe actually issued for a connection. Existing
// connections predate this tracking and are assumed read_only (the more
// restrictive assumption) rather than read_write.
export enum StripeConnectionScope {
    READ_WRITE = "read_write",
    READ_ONLY = "read_only",
}

// How the Stripe account behind this connection was established:
// - `oauth`: an existing client Stripe imported for bookkeeping (Standard
//   Connect). This is the only kind that predates the column, so every existing
//   row defaults to `oauth`.
// - `express`: a Kick-created Express account used for native invoice payment
//   collection. Payment eligibility keys off this, never off `scope`.
export enum StripeConnectionKind {
    OAUTH = "oauth",
    EXPRESS = "express",
}

export interface StripeConnection extends FinancialConnection {
    error: StripeConnectionErrorType | null;
    scope: StripeConnectionScope;
    kind: StripeConnectionKind;
    detailsSubmitted: boolean;
    chargesEnabled: boolean;
}
